/*
    Copyright 2022-2026, Techwise Integrated Security, LLC
*/

import { getHandler, stdErrHandlerFactory } from "../../utils/Requests";

import { Pagination, Setter, StorageLocationDetailed } from "../../utils/Interfaces";

import { AnyAction, Dispatch } from "@reduxjs/toolkit";
import { AxiosResponse } from "axios";
import { LocationType } from "../../utils/Constants";

export function updateRestockingTasks(
    techwiseOfficeId: number,
    locationType: LocationType,
    dispatch: Dispatch<AnyAction>,
    setStorageLocations: Setter<StorageLocationDetailed[]>,
    setLoading: Setter<boolean>
) {
    getHandler<Pagination<StorageLocationDetailed>>(
        `/api/inventory/restocking/${techwiseOfficeId}/${locationType}`,
        dispatch,
        (response: AxiosResponse<Pagination<StorageLocationDetailed>, any>) => {
            setStorageLocations(response.data.results);
        },
        stdErrHandlerFactory(dispatch),
        setLoading
    );
}
